import React, { ChangeEvent, ChangeEventHandler, Component } from 'react';
import { connect } from 'react-redux';

import { FormControl, Input, InputLabel, Theme, Typography } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Snackbar from '@material-ui/core/Snackbar';
import withStyles, { Styles } from '@material-ui/core/styles/withStyles';
import { Dispatch } from 'redux';
import { ReactComponent as GoogleLogo } from '../assets/GoogleLogo.svg';

import { login as loginAction } from '../actions/auth';
import mainLogo from '../assets/logo.svg';
import { State as AppState } from '../reducers/typings';
import { loginWithGoogle } from '../services/auth';

const styles: Styles<Theme, {}> = (theme: Theme) => ({
  main: {
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(3 * 2))]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    marginTop: theme.spacing(3),
  },
  googleSignInLogo: {
    width: 24,
    height: 24,
  },
  avatar: {
    margin: theme.spacing(1),
    width: '70px',
    height: '70px',
  },
});

interface Props {
  classes: Record<string, string>;
  loginFailure: boolean;
  login(username: string, password: string): void;
}

interface State {
  email: string;
  password: string;
}

class LoginForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      email: '',
      password: '',
    };
  }

  handleChange = (name: string): ChangeEventHandler<HTMLInputElement> => (
    event: ChangeEvent<HTMLInputElement>,
  ): void => {
    const { value } = event.target;
    this.setState(
      (previousState: State): State => ({
        ...previousState,
        [name]: value,
      }),
    );
  };

  buttonClicked = async () => {
    const { email, password } = this.state;
    const { login } = this.props;
    login(email, password);
  };

  render() {
    const { classes, loginFailure } = this.props;

    return (
      <main className={classes.main}>
        <Paper className={classes.paper}>
          <Avatar src={mainLogo} className={classes.avatar} />
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>

          <form className={classes.form}>
            <FormControl margin="normal" required fullWidth>
              <InputLabel htmlFor="email">Email Address</InputLabel>
              <Input
                id="email"
                name="email"
                placeholder="Email"
                autoComplete="email"
                onChange={this.handleChange('email')}
                autoFocus
              />
            </FormControl>
            <FormControl margin="normal" required fullWidth>
              <InputLabel htmlFor="password">Password</InputLabel>
              <Input
                name="password"
                placeholder="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                onChange={this.handleChange('password')}
              />
            </FormControl>

            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={this.buttonClicked}
            >
              Sign in
            </Button>

            <Button
              fullWidth
              variant="outlined"
              color="primary"
              className={classes.submit}
              onClick={loginWithGoogle}
              startIcon={<GoogleLogo className={classes.googleSignInLogo} />}
            >
              Google Sign in
            </Button>
          </form>
        </Paper>

        <Snackbar
          message="Une erreur est survenue, vérifiez vos identifiants"
          open={loginFailure}
          autoHideDuration={1500}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        />
      </main>
    );
  }
}

function mapStateToProps(state: AppState): Pick<Props, 'loginFailure'> {
  return {
    loginFailure: state.auth.loginFailure,
  };
}

function mapDispatchToProps(dispatch: Dispatch): Pick<Props, 'login'> {
  return {
    login(username: string, password: string) {
      // @ts-ignore redux-thunk definition issue
      return dispatch(loginAction(username, password));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(LoginForm));
